import React, { useContext } from 'react';
import '../styles/NewPost.css';
import { ThemeContext } from '../context/ThemeContext';

const NewPostButton = ({ onClick }) => {
  const { theme } = useContext(ThemeContext);
  
  // Get theme-specific post plus icon
  const getPostPlusIcon = () => {
    return theme === 'dark' ? '/images/post-plus-dark.svg' : '/images/post-plus-light.svg';
  };

  return (
    <button className="new-post-modal-button" onClick={onClick}>
      <div className="post-plus-container">
        <img src={getPostPlusIcon()} alt="New Post" width="35" height="35" />
      </div>
    </button>
  );
};

export default NewPostButton;
